import { PageStoryblok } from '@/lib/types/component-types-sb'
import { storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc'

export function Page({ blok }: { blok: PageStoryblok }) {
  return (
    <div
      {...storyblokEditable(blok)}
      className="content-type--page"
    >
      {blok.body?.map((blok) => (
        <StoryblokServerComponent
          blok={blok}
          key={blok._uid}
        />
      ))}
    </div>
  )
}
